import {cookieMgr} from './utils'
import Thumbnail from './components/thumbnail'
import Selector from './components/selector'
import TagList from './components/tagList'
import Page from './components/page'

import Dropdown from './ui/dropdown'
import Modal from './ui/modal'

import searchTranslate from 'tc-search-translate'
import searchSuggest from 'tc-search-suggestion'

import {alphabeticalFilter} from './modules'

$(function () {
  window.page = new Page();
  window.page.init();

  if (window.page.face === 'pornstars')
    window.page.alphabetical('.tcats li', 'h3', '.alphabetical');

  $('.alphabetical-filter').each(alphabeticalFilter)

  $('.group-selector').each(function (index) {
    var selector = new Selector(this);
    selector.init();
  });

  $('.categories_list').each(function () {
    var tagList = new TagList(this);
    tagList.init();
  });

  var thumbnails = [];
  $('.videos > li').each(function (index) {
    var thumbnail = new Thumbnail(this);
    thumbnail.init();

    thumbnails.push(thumbnail);
  });

  $('[data-modal]').each(function (index) {
    var modal = new Modal(this);
  });

  $('[data-dropdown]').each(function (index) {
    var dropdown = new Dropdown(this);
  });

  var $thumbToggler = $('.toggle-thumb');

  $thumbToggler.on('click', function () {
    var thumbWide = cookieMgr.get('thumbWide');
    var isWide = thumbWide === 'true';

    toggleWide(!isWide);
  });

  function toggleWide(isWide) {
    var $thumbs = $('.thumba, .tcats ul li, .vda-item');
    var removeClass = isWide ? 'i--grid' : 'i--grid2';
    var addClass = isWide ? 'i--grid2' : 'i--grid';
    var method = isWide ? 'addClass' : 'removeClass';

    var $icon = $thumbToggler.find('i');

    $icon.removeClass(removeClass).addClass(addClass);
    $thumbs[method]('wide');

    cookieMgr.set('thumbWide', isWide);

    for (var i = 0, len = thumbnails.length; i < len; i++) {
      var thumbnail = thumbnails[i];

      thumbnail.tagsArrow();
    }
  }

  window.addEventListener("orientationchange", function () {
    for (var i = 0, len = thumbnails.length; i < len; i++) {
      var thumbnail = thumbnails[i];

      thumbnail.tagsArrow();
    }
  }, false);

  $(document.body).on('click', '.tabs__tab', function (e) {
    e.preventDefault();

    var $this = $(this);
    var $tabsContainer = $this.parents('.tabs');
    var $panels = $tabsContainer.find('.tabs__body .tabs__panel');
    var index = $this.index();
    var $activePanel = $panels.eq(index - 1);

    $this.add($activePanel).addClass('is-active').siblings().removeClass('is-active');
  });

  $("#back_to_top").hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 1000) {
      $('#back_to_top').fadeIn();
    } else {
      $('#back_to_top').fadeOut();
    }
  });
  $('#back_to_top a').click(function () {
    $('body,html').scrollTop(300).animate({
      scrollTop: 0
    }, 200);
    return false;
  });

  // Network menu
  var ww = window.innerWidth,
    $network = $('.our-network'),
    $networkItem = $network.find('.our-network__list-item'),
    $networkLabel = $network.find('.our-network__label'),
    $networkDropdown = $network.find('.our-network__dropdown'),
    $networkDropdownList = $network.find('.our-network__dropdown-list');

  $(window).on("resize", function (e) {
    var ww = window.innerWidth;
    networkMenu();
    if ($networkDropdown.eq(0).hasClass('our-network__dropdown--active')) {
      $networkDropdown.eq(0).removeClass('our-network__dropdown--active');
    }
  })


  function networkMenu() {
    var ww = window.innerWidth;
    if (ww >= 1510) {
      $networkItem.insertBefore($networkDropdown.eq(1));
    }
    if (ww < 1510 && ww >= 1260) {
      $networkItem.insertBefore($networkDropdown.eq(1));
      $networkDropdownList.eq(1).append($networkItem.slice(-4));
    }
    ;
    if (ww < 1260) {
      $networkDropdownList.eq(0).append($networkItem);
    }
    ;
  };
  networkMenu();

  function networkClick() {
    $networkDropdown.eq(1).on('click', function (e) {
      if (e.target.className.indexOf('our-network__link') > -1) return;
      $networkDropdownList.eq(1).toggleClass('our-network__dropdown-list--open');
      $networkDropdown.eq(1).toggleClass('our-network__dropdown--active');
    });

    $networkDropdown.eq(0).on('click', function (e) {
      if (e.target.className.indexOf('our-network__link') > -1) return;
      var ww = window.innerWidth;
      if (ww < 1260) {
        $networkDropdownList.eq(0).toggleClass('our-network__dropdown-list--open');
        $networkDropdown.eq(0).toggleClass('our-network__dropdown--active');
      } else {
        return false;
      }
    });
  };
  networkClick();

  (function showNetworkLabel() {
    $networkLabel.css('display', 'inline-block');
  })();

  $('#catmenu #btnaz').click(function () {
    $('#catbody div#ps').hide();
    $('#catbody div#az').show();
    $(this).addClass('active');
    $('#catmenu #btnps').removeClass('active');
  })
  $('#catmenu #btnps').click(function () {
    $('#catbody div#az').hide();
    $('#catbody div#ps').show();
    $(this).addClass('active');
    $('#catmenu #btnaz').removeClass('active');
  })
  $('#catbody div#ps').hide();


  searchSuggest({
    form: '#searchform',
    isLang: true,
    isReset: true
  });
  searchTranslate({
    form: '#searchform',
    isLang: true
  });

});



// WEBPACK FOOTER //
// ./src/desktop/scripts/common.js